import React from "react";
import { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Profile from "./Profile";
import ArticlesList from "./Bibliography/Articles";
import BookList from "./Bibliography/Book";

import "../styles/DrBach.css";
import EditorialsAndChapters from "./Bibliography/EditsAndChapters";
import LettersAndContributions from "./Bibliography/LettersAndContributions";
import ReportsAndAbstracts from "./Bibliography/ReportsAndAbstracts";
import MediaAndCD from "./Bibliography/MediaAndCD-ROMs";
import Publications from "./Bibliography/Publications";

const DrBach = () => {
  const [selected, setSelected] = useState("Articles");
  const [transitioning, setTransitioning] = useState(false);
  const [list] = useState([
    "Articles",
    "Monographs & Books",
    "Editorials & Chapters",
    "Letters & Contributions",
    "Reports & Abstracts",
    "Media & CD-ROMs",
    "Publications",
  ]);

  const handleSelect = (item) => {
    if (item === selected) return;
    setTransitioning(true);
    setTimeout(() => {
      setSelected(item);
      setTransitioning(false);
    }, 200); // match your CSS animation duration
  };
  const renderComponent = () => {
    switch (selected) {
      case "Articles":
        return <ArticlesList />;
      case "Monographs & Books":
        return <BookList />;
      case "Editorials & Chapters":
        return <EditorialsAndChapters />;
      case "Letters & Contributions":
        return <LettersAndContributions />;
      case "Reports & Abstracts":
        return <ReportsAndAbstracts />;
      case "Media & CD-ROMs":
        return <MediaAndCD />;
      case "Publications":
        return <Publications />;
      default:
        return <ArticlesList />;
    }
  };

  return (
    <div className="comp-div">
      <title>Dr. John R. Bach</title>
      <HelmetProvider>
        <Helmet>
          <title>Dr. John R. Bach | DoctorBach</title>
          <meta
            name="description"
            content="Profile of Dr. John R. Bach, Professor of Neurology at Rutgers University NJMS and a global leader in noninvasive ventilation and neuromuscular care."
          />
          <meta
            name="keywords"
            content="Dr. John R. Bach, noninvasive ventilation, neuromuscular disease, Rutgers NJMS, respiratory care"
          />
          <meta name="author" content="DoctorBach.com" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />

          {/* Open Graph (Facebook, LinkedIn) */}
          <meta property="og:title" content="Dr. John R. Bach | DoctorBach" />
          <meta
            property="og:description"
            content="Learn about Dr. John R. Bach, Professor of Physical Medicine and Rehabilitation, and his contributions to noninvasive respiratory care."
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/images/BachJohn.jpg"
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta property="og:url" content="https://doctorbach.com/drbach" />
          <meta property="og:type" content="profile" />
        </Helmet>
      </HelmetProvider>
      <Profile />
      <div className="input-filt">
        {list.map((item) => (
          <button
            key={item}
            className={`checkbox-button ${selected === item ? "checked" : ""}`}
            onClick={() => handleSelect(item)}
          >
            {item}
          </button>
        ))}
      </div>
      <div className="content-area">
        <div
          className={`selected-component ${
            transitioning ? "fade-out" : "fade-in"
          }`}
        >
          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default DrBach;
